
import Vue from "vue";

export default Vue.extend<{}, {}, Computed, {}>({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  computed: {
    title() {
      return this.$t('accountDeletedPage.title');
    },
    description() {
      return this.$t('accountDeletedPage.description');
    },
  },
});

interface Computed {
  title: string;
  description: string;
}
